import MultiSelectPage from "@components/MultiSelectPage"

const OPTIONS = [
  "dailySummaries",
  "mealSuggestions",
  "weeklyReports",
  "motivationalMessages",
  "nutritionalTips",
  "justTracking",
] as const

export default function CoachingFeatures() {
  return (
    <MultiSelectPage
      translationKey="coachingFeatures"
      options={OPTIONS}
      noneOptionKey="justTracking"
    />
  )
}
